var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 0C58.7832 0 38.4347 8.42845 23.4309 23.4309C8.42846 38.4347 0 58.7823 0 80C0 101.218 8.42846 121.565 23.4309 136.569C38.4347 151.572 58.7823 160 80 160C101.218 160 121.565 151.572 136.569 136.569C151.572 121.565 160 101.218 160 80C160 58.7823 151.572 38.4347 136.569 23.4309C121.565 8.42845 101.218 0 80 0ZM80 126.897C67.5629 126.897 55.6343 121.956 46.8398 113.161C38.0453 104.366 33.1047 92.4374 33.1047 80.0013C33.1047 67.5651 38.0456 55.6355 46.8398 46.8411C55.6352 38.0466 67.5638 33.106 80 33.106C92.4362 33.106 104.366 38.0469 113.16 46.8411C121.955 55.6365 126.895 67.5651 126.895 80.0013C126.895 92.4374 121.954 104.367 113.16 113.161C104.365 121.956 92.4362 126.897 80 126.897Z",
    fill: "url(#paint0_linear_3151_2206)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3151_2206",
    x1: 80,
    y1: 0,
    x2: 80,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68CAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3080DE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelBackground);
export default __webpack_public_path__ + "static/media/wheel-background.4596ce7b4dac1b60c70a4a36e20b1592.svg";
export { ForwardRef as ReactComponent };